// Copyright (c) 2020 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

export {default as Add} from './add';
export {default as ArrowDown} from './arrow-down';
export {default as ArrowDownAlt} from './arrow-down-alt';
export {default as ArrowDownSolid} from './arrow-down-alt';
export {default as ArrowLeft} from './arrow-left';
export {default as ArrowRight} from './arrow-right';
export {default as ArrowUpSolid} from './arrow-up-solid';
export {default as ArrowUpAlt} from './arrow-up-alt';
export {default as ArrowUp} from './arrow-up';
export {default as Base} from './base';
export {default as Bug} from './bug';
export {default as Cancel} from './cancel';
export {default as Checkmark} from './checkmark';
export {default as Clipboard} from './clipboard';
export {default as Clock} from './clock';
export {default as Close} from './close';
export {default as Crosshairs} from './crosshairs';
export {default as Cube3d} from './cube-3d';
export {default as CursorClick} from './cursor-click';
export {default as DataTable} from './data-table';
export {default as Db} from './db';
export {default as Delete} from './delete';
export {default as Docs} from './docs';
export {default as DragNDrop} from './drag-n-drop';
export {default as Email} from './email';
export {default as Expand} from './expand';
export {default as EyeSeen} from './eye-seen';
export {default as EyeUnseen} from './eye-unseen';
export {default as File} from './file';
export {default as Files} from './files';
export {default as FileType} from './file-type';
export {default as FilterFunnel} from './filter-funnel';
export {default as Gear} from './gear';
export {default as Hash} from './hash';
export {default as Histogram} from './histogram';
export {default as Info} from './info';
export {default as Layers} from './layers';
export {default as LeftArrow} from './left-arrow';
export {default as Legend} from './legend';
export {default as LineChart} from './line-chart';
export {default as Logout} from './logout';
export {default as Login} from './login';
export {default as Map} from './map';
export {default as MapIcon} from './map-icon';
export {default as Minus} from './minus';
export {default as Messages} from './messages';
export {default as Pause} from './pause';
export {default as Picture} from './picture';
export {default as Pin} from './pin';
export {default as Play} from './play';
export {default as Reduce} from './reduce';
export {default as Reset} from './reset';
export {default as Rocket} from './rocket';
export {default as Save} from './save';
export {default as Save2} from './save2';
export {default as Share} from './share';
export {default as SquareSelect} from './square-select';
export {default as Settings} from './settings';
export {default as Search} from './search';
export {default as Split} from './split';
export {default as Table} from './table';
export {default as Trash} from './trash';
export {default as Upload} from './upload';
export {default as VertDots} from './vert-dots';
export {default as VertThreeDots} from './vert-three-dots';
export {default as IconWrapper} from './base';
export {default as CodeAlt} from './code-alt';
export {default as Warning} from './warning';
export {default as DrawPolygon} from './draw-polygon';
export {default as Polygon} from './polygon';
export {default as Rectangle} from './rectangle';
